import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from "../../AuthContext";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
// import CircularProgress from "@material-ui/core/CircularProgress";

import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import ScheduleForm from "../../components/settings/ScheduleForm";
import CashToggleForm from "../../components/settings/CashToggleForm";
import PinSetter from "../../components/settings/PinSetter";
import { Typography } from "@material-ui/core";

const SCHEDULE = "schedule";
const CASHTOGGLE = "cash";
const PINSETTER = "pin";

export default function Settings() {
	const [settingsData, setSettingsData] = useState();
	const [isSaving, setIsSaving] = useState(false);
	const [displayingSection, setDisplayingSection] = useState("");
	const {
		databasesRef: { settingsDB },
	} = useContext(AuthContext);

	useEffect(() => {
		if (settingsDB) {
			return settingsDB.onSnapshot((doc) => {
				const data = doc.data();
				setSettingsData(data);
			});
		}
	}, [settingsDB]);

	const onSubmit = async (data) => {
		try {
			setIsSaving(true);
			await settingsDB.update(data);
			alert("Se ha guardado correctamente");
			setIsSaving(false);
		} catch (error) {
			alert("Ha ocurrido un error");
			setIsSaving(false);
		}
	};

	const returnButton = <ButtonWithStyle onClick={() => setDisplayingSection("")}>Regresar</ButtonWithStyle>;

	const scheduleForm = (
		<>
			<Typography variant="h5">Horario</Typography>
			<ScheduleForm data={settingsData} onSubmit={onSubmit} isLoading={isSaving} />
			{returnButton}
		</>
	);

	const cashForm = (
		<>
			<Typography variant="h5">Recibir efectivo</Typography>
			<CashToggleForm data={settingsData} onSubmit={onSubmit} isLoading={isSaving} />
			{returnButton}
		</>
	);

	const pinSetter = (
		<>
			<Typography variant="h5">Pin de Seguridad</Typography>
			<PinSetter data={settingsData} onSubmit={onSubmit} isLoading={isSaving} />
			{returnButton}
		</>
	);

	const sectionHandler = () => {
		switch (displayingSection) {
			case SCHEDULE:
				return scheduleForm;
			case CASHTOGGLE:
				return cashForm;
			case PINSETTER:
				return pinSetter;
			default:
				return sectionSelector;
		}
	};
	const sectionSelector = (
		<>
			<ButtonWithStyle onClick={() => setDisplayingSection(SCHEDULE)}>Cambiar Horario</ButtonWithStyle>
			<ButtonWithStyle onClick={() => setDisplayingSection(CASHTOGGLE)}>Activar o desactivar efectivo</ButtonWithStyle>
			<ButtonWithStyle onClick={() => setDisplayingSection(PINSETTER)}>Cambiar Pin de seguridad</ButtonWithStyle>
		</>
	);

	return (
		<Container
			style={{
				paddingTop: "1em",
			}}
		>
			<Paper style={{ padding: "1em", textAlign: "center" }}>{settingsData && sectionHandler()}</Paper>
		</Container>
	);
}
